import toast from 'react-hot-toast';
import { httpRequest } from './httpRequest';

export const handlePreviewFile = async (url: string) => {
  const blobName = url.split('/').slice(4).join('/');
  if (!blobName) {
    toast.error('Invalid file URL');
    return;
  }

  // Open window immediately with a loading page
  const newWindow = window.open('about:blank', '_blank');

  try {
    const response = await httpRequest(
      'GET',
      `/bid_portal/bids/uploadFile?blobName=${blobName}`
    );
    if (response?.fileURL) {
      // Update the window location once we have the URL
      if (newWindow) {
        newWindow.location.href = response.fileURL;
      }
    } else {
      newWindow?.close();
      toast.error('No file URL returned');
    }
  } catch (err) {
    newWindow?.close();
    toast.error(
      'Error fetching file preview: ' +
        (err instanceof Error ? err.message : 'Unknown error')
    );
  }
};

export function addCommaWithTwoDecimals(value?: string): string {
  if (!value) return '';

  // Remove existing commas
  const cleanValue: string = value.replace(/,/g, '');

  // Allow only numbers and one decimal point
  if (!/^\d*\.?\d*$/.test(cleanValue)) {
    return value;
  }

  // Handle only decimal input
  if (cleanValue === '.') {
    return '0.';
  }

  const [integerPart = '0', decimalRaw] = cleanValue.split('.');

  // Add commas for US format
  const formattedInt: string = integerPart.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ','
  );

  // If no decimal part, return integer only
  if (decimalRaw === undefined) {
    return formattedInt;
  }

  // Limit decimal to 2 digits
  return `${formattedInt}.${decimalRaw.slice(0, 2)}`;
}
